import {Injectable, inject} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {map, retry} from 'rxjs/operators';
import {Alphabets} from '@ccp/enums/alphabets.enum';
import {HttpTypeHeaderEnum} from '@ccp/enums/http-type-header.enum';
import {environment} from '@ccp/environments/global/environment';
import {genericRetryStrategy} from '@ccp/lib/http-error-handling';
import {HttpHeadersService} from '@ccp/services/Auth/http-headers.service';
import {ConfigService} from '@ccp/services/configuration/config.service';
import {Transliteration} from '@ccp/models/transliteration.model';

@Injectable({
  providedIn: 'root',
})
export class TransliterationService {
  private readonly http = inject(HttpClient);
  private readonly httpHeaderService = inject(HttpHeadersService);
  private readonly configService = inject(ConfigService);

  /**
   * Transliterate text from one alphabet to another
   *
   * @param input - The text to transliterate
   * @param from - Source alphabet
   * @param to - Target alphabet
   * @param language - Language ISO code
   * @returns Observable<string> - The transliterated text
   *
   */
  public getTransliteration(input: string, from: Alphabets, to: Alphabets, language: string): Observable<string> {
    return this.http
      .post<Transliteration[]>(
        environment.api.endPoints.transliteration,
        {input, from, to, language},
        {
          headers: this.httpHeaderService.getHttpHeaderByType(HttpTypeHeaderEnum.basic),
        },
      )
      .pipe(
        map((response: Transliteration[]) => {
          const transliteration = response.find((item) => item.script === to);
          return transliteration ? transliteration.text : '';
        }),
        retry(genericRetryStrategy({listHttpErrorToRetry: this.configService.config$()?.app?.httpErrorToRetry})),
      );
  }
}
